// extracted by mini-css-extract-plugin
export default {"container":"priceDetails_container__Gfk48","includes":"priceDetails_includes__iMQLk","excludes":"priceDetails_excludes__nbfaN"};